<template>
  <div class="cla-accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: [
    
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .cla-accordion {
        font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;   
    }
</style>